import { z } from "zod";

export const intoleranceFormSchema = z.object({
  name: z.string().min(1, { message: "Name is required." }),
  allergyReaction: z.string().min(1, { message: "Symptoms is required." }),
  serious: z.boolean(),
  note: z.string().nullable().optional(),
});
